import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { setCredentials, globalLogout } from '../features/authentication/authSlice';

import appConfig from '../app-config';
import { captureServerIp } from '../utils/serverIpHelper';
import CustomToast from '../components/Toast';
import { normalizeValidationErrors } from './errorHandlers/normalizeValidationErrors';

const baseUrl = appConfig.apiBaseUrl;

const baseQuery = fetchBaseQuery({
  baseUrl: baseUrl,
  credentials: 'include',
  prepareHeaders: (headers, { getState }) => {
    const token = getState().auth.accessToken;
    if (token) {
      headers.set('authorization', `Bearer ${token}`);
    }
    return headers;
  }
});

const baseQueryWithReauth = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);

  captureServerIp(result, api);

  // If unauthorized try getting new token with the refresh token
  if (result?.error?.status === 401) {
    var refreshArgs = {
      url: 'Account/RefreshToken',
      method: 'POST',
      credentials: 'include'
    };

    // send refresh token to get new access token
    const refreshResult = await baseQuery(refreshArgs, api, extraOptions);
    captureServerIp(refreshResult, api);

    if (refreshResult?.data) {

      // Store the new token
      api.dispatch(
        setCredentials({
          accessToken: refreshResult.data.accessToken
        })
      );
      // Retry original query with the new token
      result = await baseQuery(args, api, extraOptions);
      captureServerIp(refreshResult, api);
    } else {
      api.dispatch(globalLogout());
    }
  }
  else if(result?.error?.status === 400 && result.error.data?.errors) {
    const validationErrors = normalizeValidationErrors(result.error.data.errors);
    result.error.validationErrors = validationErrors;

    if (extraOptions.showGlobalError) {
      const firstError = Object.values(validationErrors)[0];
      CustomToast(firstError, 'error');
    }
    return result;
  }
  else if(result?.error?.status === 403) {
    CustomToast('You do not have permission to perform this action.', 'error');
  }
  else if (result?.error 
  && extraOptions?.showGlobalError
  ) {
    const message =
      result.error?.data?.error ||
      'Unexpected server error';
    CustomToast(message, 'error');
  }
  return result;
};

export const apiSlice = createApi({
  baseQuery: baseQueryWithReauth,
  // eslint-disable-next-line no-unused-vars
  endpoints: (builder) => ({}),
  refetchOnMountOrArgChange: true
});

export const classicApi = createApi({
  baseQuery: fetchBaseQuery({ baseUrl: 'https://localhost:443' }),
  // eslint-disable-next-line no-unused-vars
  endpoints: (builder) => ({})
});
